import React, { useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';
import { useNotifications } from '@utils/hooks';
import i18n, { LanguageType } from '@utils/i18n';

import { globalActions, useStore } from '@modules';

import Dropdown from '@components/Dropdown';

import SelectField from '../SelectField';

import style from './Language.scss';

const cn = bemCssModules(style, 'Language');
const ti = getTestId('Language');

export type DataType = { value: string; label: string }[];

const langOptions = Object.values(CONST.i18n.languages).reduce<DataType>((acc, { code, name }) => {
  const option = { value: code, label: name };
  return [...acc, option];
}, []);

export const Language: CustomFC = props => {
  const { className } = props;

  const { t } = useTranslation();
  const [{ user }, dispatch] = useStore();
  const langRef = useRef<HTMLButtonElement>(null);
  const userLanguage = user.data?.language_code?.slice(0, 2);
  const language = CONST.i18n.languages[userLanguage || i18n.language].code;
  const languageName = userLanguage && CONST.i18n.languages[userLanguage].name;

  const { successEditSettingsNotification } = useNotifications();

  if (!language) return null;
  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <SelectField ref={langRef} label={t('settings.language')}>
        {languageName}
      </SelectField>
      <Dropdown
        className={cn('modal')}
        data={langOptions}
        value={language}
        onChange={({ value }) => {
          if (value !== language) {
            const short = value.slice(0, 2);
            i18n.changeLanguage(short);
            dispatch(globalActions.setLang(short as LanguageType));
            successEditSettingsNotification('language_code', value);
          }
        }}
        controller={langRef}
      />
    </div>
  );
};

export default Language;
